import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { DictionaryApiService } from 'src/app/core/service/abstract/dictionary-api.service';
import { ReadApiService } from 'src/app/core/service/abstract/read-api.service';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { UserTableVisualization } from 'src/app/data/model/user';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: 'root',
})
export class DictionaryUserTableVisualizationApiService extends DictionaryApiService<UserTableVisualization> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('portal/auth/user-module-visual', http, config);
  }
}
